// @flow
import { RESORT_ACCESS_AND_MAP } from 'Client/cms/toolkit/constants';
import { ProductAccessAndMapLine } from 'Components/lines/product-access-and-map-line/ProductAccessAndMapLine.jsx';
import { productAccessAndMapResolver } from './productAccessAndMap.resolver';

export const productAccessAndMapDescriptor = {
  name: RESORT_ACCESS_AND_MAP,
  component: ProductAccessAndMapLine,
  resolve: productAccessAndMapResolver.resolve,
};
